
export const tes = {
    'default': 'Default',
    'data_one': 'Data One',
    'data_two': 'Data Two',
    'data_three': 'Data Three',
    'data_four': 'Data Four',
    'data_five': 'Data Five',
    'data_six': 'Data Six',
    'data_seven': 'Data Seven',
    'data_eight': 'Data Eight',
    'data_nine': 'Data Nine',
    'data_ten': 'Data Ten',
}

export const dataStoresOptions: { id: string, value: string }[] = [
    { id: 'default', value: 'Default' },
    { id: 'data_one', value: 'Data One' },
    { id: 'data_two', value: 'Data Two' },
    { id: 'data_three', value: 'Data Three' },
    { id: 'data_four', value: 'Data Four' },
    { id: 'data_five', value: 'Data Five' },
    { id: 'data_six', value: 'Data Six' },
    { id: 'data_seven', value: 'Data Seven' },
    { id: 'data_eight', value: 'Data Eight' },
    { id: 'data_nine', value: 'Data Nine' },
    { id: 'data_ten', value: 'Data Ten' },
    { id: 'scraper_pending', value: 'Scraper Pending' },
    // { id: 'data_eleven', value: 'Data Eleven' },
    // { id: 'data_twelve', value: 'Data Twelve' },
    //
    // { id: 'data_thirteen', value: 'Data Thirteen' },
    // { id: 'data_fourteen', value: 'Data Fourteen' },
    // { id: 'data_fifteen', value: 'Data Fifteen' },
    // { id: 'data_sixteen', value: 'Data Sixteen' },
    // { id: 'data_seventeen', value: 'Data Seventeen' },
    // { id: 'data_eighteen', value: 'Data Eighteen' },
    // { id: 'data_nineteen', value: 'Data Nineteen' },
    // { id: 'data_twenty', value: 'Data Twent' },

    { id: 'messages', value: 'Messages' },
    { id: 'data_to_loop', value: 'Loop Data Slot (only works in loops)' },
    { id: 'latest_user_message', value: 'Lastest User Message' },
    { id: 'hq_params', value: 'HQ Params (used in tools) ' }
];

export const workflowSettingsHelperText = {
    'memory': "Enables the workflow to use long term memory (PostgreSQL database). " +
        "\n\nThis will help any AI elements to learn and remember over time. \n\n" +
        "Short Term Memory (STM) is enabled by default.",
    'error_exit': "This will cause the workflow to exit if an error occurs. \n\n" +
        "Having this enabled is recommended under most circumstances.",
    'default_exit': "Change the location the return value is pulled from.\n\nDefault is the LLM messages. "
}
